import React from 'react'
import { Card } from 'antd-mobile-v5'
import { FormattedMessage } from 'react-intl'
import UserPhoto from '../common/UserPhoto'
import { formatDate } from '../common/utils'

import styles from './tools.module.css'

const DiverInfo = ({ info }) => {
  return (
    <Card
      title={
        <div style={{ fontWeight: 'normal' }}>
          <FormattedMessage id="dm-form-diver-info" />
        </div>
      }
      style={{ borderRadius: '16px' }}
    >
      <div className={styles['info-body']}>
        <div className={styles['info-photo']}>
          <UserPhoto id={info.affiliateId} />
        </div>
        <div className={styles['info-wrapper']}>
          <div className={styles['info-left']}>
            <div>
              <FormattedMessage id="profile-name" />
            </div>
            <div>
              <FormattedMessage id="dm-form-birth" />：
            </div>
            <div>
              <FormattedMessage id="fd-pic-email" />
            </div>
          </div>
          <div className={styles['info-right']}>
            <div className={styles.info}>{info.englishName}</div>
            <div className={styles.info}>{formatDate(info.birthDate, 'YYYY-MM-DD')}</div>
            <div className={styles.info}>{info.email}</div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default DiverInfo
